import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=0fa66d78"
import script from "./dashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PortfolioKeyFacts: require('/home/runner/work/assessment-service/assessment-service/frontend/components/portfolio/KeyFacts.vue').default,PortfolioEsgPerformance: require('/home/runner/work/assessment-service/assessment-service/frontend/components/portfolio/EsgPerformance.vue').default,PortfolioAggregatedKpis: require('/home/runner/work/assessment-service/assessment-service/frontend/components/portfolio/AggregatedKpis.vue').default,PortfolioImpactGoalPerformance: require('/home/runner/work/assessment-service/assessment-service/frontend/components/portfolio/ImpactGoalPerformance.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,AddCompanyToPortfolioCard: require('/home/runner/work/assessment-service/assessment-service/frontend/components/AddCompanyToPortfolioCard.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default,IxPageLoading: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/PageLoading.vue').default})
